module.exports = __webpack_public_path__ + "img/img_kv_1_thumb.94d2c57c.jpg";